<template>
    <div class="bottom-border">
        <div class="container-fluid">
            <div class="row remove-a">
                <div class="col-6">
                    <router-link :to="{name: 'vignette'}" class="checkout-tab-button text-center">
                        <b>{{ $tc('vignetteWord', 1) }}</b>
                    </router-link>
                </div>
                <div class="col-6">
                    <router-link :to="{name: 'toll'}" class="checkout-tab-button text-center">
                        <b>{{ $tc('tollWord', 1) }}</b>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'MainNavigation',
    props: {
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

$green: #59af54;
$lightgrey: lightgrey;

.router-link-exact-active {
    border-bottom-color: $green !important;
    border-bottom-width: 3px !important;
    border-bottom-style: solid !important;
    margin-bottom: -2px !important;
    color: $green !important;
    p {
        color: $green !important;
    }
}

.checkout-tab-button {
    padding: 13px 0px 13px 0px;
    display: block;
    font-size: 14px;
    color: $lightgrey;
    margin-bottom: 0px;
}

</style>
